import * as R from 'ramda'
import React from 'react'
import qs from 'query-string'
import { Pagination } from 'antd'
import { Link } from 'react-router-dom'
import { Button } from 'semantic-ui-react'
import { getParticipants } from '../api/async/participants/index'
import { getMyMedal } from '../api/sync/races/index'
import { getUserMe } from '../api/async/users/index'
import avatarFemale from '../assets/avatar_female.png'
import avatarMale from '../assets/avatar_male.png'
import {
  MobileParticipantCard,
  ParticipantCard
} from '../components/ParticipantCard/index'
import RaceStat from '../components/RaceStat/index'
import RequireLogin from '../components/RequireLogin/index'
import { endRegisterRace, formatDateTime } from '../utils/index'
import { IndividualMedal } from '../components/IndividualMedal'
import { Loader } from '../components/Loader'
import { AuthUserWithLine } from '../api/sync'

class Profile extends React.Component {
  state = {
    participants: [],
    showParticipants: [],
    loading: true,
    medals: []
  }

  componentDidMount() {
    getParticipants().then(res => {
      const participants = res.data.filter(
        each =>
          !endRegisterRace(R.path(['race_detail', 'race'], each)) ||
          each.is_paid
      )
      const showParticipants = participants.slice(0, 5)
      this.setState({ participants })
      this.setState({ showParticipants })
    })
    getUserMe().then(res => this.setState({ user: res.data }))
    getMyMedal().then(res => {
      this.setState({ loading: false })
      this.setState({ medals: res.data.results })
    })

    const params = this.getParams()
    if (params.code) AuthUserWithLine(params.code)

    document.title = 'Run24Hrs - งานวิ่งของฉัน'
  }

  getParams = () => {
    const queryString = this.props.location.search
    return qs.parse(queryString)
  }

  handlePaginateChange = offset => {
    this.setState({
      showParticipants: this.state.participants.slice(
        (offset - 1) * 5,
        offset * 5
      )
    })
  }

  getAvatar = () => {
    const gender = R.path(['gender'], this.state.user)
    let avatar = avatarMale
    if (gender === 'female') avatar = avatarFemale
    return R.pathOr(avatar, ['profile_picture'], this.state.user)
  }

  render() {
    const params = this.getParams()
    return (
      <div className="ui one column stackable centered grid">
        <div className="center aligned column">
          {this.state.user && (
            <img
              style={{ margin: '10px auto' }}
              className="ui small image circular"
              src={this.getAvatar()}
            />
          )}
          <div style={{ marginTop: 15 }}>
            <h1>{R.path(['name'], this.state.user)}</h1>
            <h2>User ID: {R.path(['bib'], this.state.user)}</h2>
            <div>
              <Link to="/edit-account">
                <Button color="teal">แก้ไขข้อมูลส่วนตัว</Button>
              </Link>
            </div>
            {!R.path(['user', 'line_user_id'], this.state) && (
              <div style={{ marginTop: 10 }}>
                <a href="https://access.line.me/oauth2/v2.1/authorize?response_type=code&client_id=1653776815&redirect_uri=https://run24hrs.com/me&state=4879387898abcde&scope=openid%20profile&nonce=09876xyz&bot_prompt=aggressive">
                  <Button
                    style={{
                      backgroundColor: '#00b900',
                      color: 'white',
                      borderRadius: 5,
                      fontSize: 18
                    }}
                  >
                    LINE Login
                  </Button>
                </a>
              </div>
            )}
          </div>
        </div>
        <div className="column">
          <div className="ui section divider" />
        </div>
        <div className="column" style={{ minHeight: 100 }}>
          <RaceStat />
        </div>
        <div className="column" style={{ height: 50 }}>
          <div className="ui section divider" />
        </div>
        <div
          className="column width80percent-desktop"
          style={{ minHeight: 100 }}
        >
          <div className="ui grid">
            <div className="three column row">
              {this.state.loading ? (
                <Loader />
              ) : (
                <React.Fragment>
                  <IndividualMedal
                    medal={this.state.medals.filter(each => each.finish_run)[0]}
                  />
                  <IndividualMedal
                    medal={this.state.medals.filter(each => each.finish_run)[1]}
                    middle
                  />
                  <IndividualMedal
                    medal={this.state.medals.filter(each => each.finish_run)[2]}
                  />
                </React.Fragment>
              )}
            </div>
          </div>
          <div style={{ textAlign: 'right', marginTop: 10 }}>
            <Link to="/my-medals">More Medals ➤</Link>
          </div>
        </div>

        <div className="column">
          <div className="ui section divider" />
        </div>
        {this.state.showParticipants.map(each => (
          <div className="column">
            <ParticipantCard
              participant={each}
              bib={each.bib}
              finish_run={each.finish_run}
              collect_distance={each.collect_distance}
              runs={each.runs}
              distanceName={R.path(['race_detail', 'distance', 'name'], each)}
              race={R.path(['race_detail', 'race'], each)}
              is_paid={each.is_paid}
              payment={each.payment[0]}
              participantId={each.id}
              featureImage={R.path(
                ['race_detail', 'race', 'feature_image'],
                each
              )}
              title={R.path(['race_detail', 'race', 'title'], each)}
              registerDate={`${formatDateTime(
                R.path(['race_detail', 'race', 'start_register_time'], each)
              )} - ${formatDateTime(
                R.path(['race_detail', 'race', 'end_register_time'], each)
              )}`}
              raceDate={`${formatDateTime(
                R.path(['race_detail', 'race', 'start_time'], each)
              )} - ${formatDateTime(
                R.path(['race_detail', 'race', 'end_time'], each)
              )}`}
              submitDate={`${formatDateTime(
                R.path(['race_detail', 'race', 'start_time'], each)
              )} - ${formatDateTime(
                R.path(['race_detail', 'race', 'last_submit_time'], each)
              )}`}
            />
            <MobileParticipantCard
              participant={each}
              bib={each.bib}
              finish_run={each.finish_run}
              collect_distance={each.collect_distance}
              runs={each.runs}
              distanceName={R.path(['race_detail', 'distance', 'name'], each)}
              is_paid={each.is_paid}
              payment={each.payment[0]}
              participantId={each.id}
              race={R.path(['race_detail', 'race'], each)}
              featureImage={R.path(
                ['race_detail', 'race', 'feature_image'],
                each
              )}
              title={R.path(['race_detail', 'race', 'title'], each)}
              registerDate={`${formatDateTime(
                R.path(['race_detail', 'race', 'start_register_time'], each)
              )} - ${formatDateTime(
                R.path(['race_detail', 'race', 'end_register_time'], each)
              )}`}
              raceDate={`${formatDateTime(
                R.path(['race_detail', 'race', 'start_time'], each)
              )} - ${formatDateTime(
                R.path(['race_detail', 'race', 'end_time'], each)
              )}`}
              submitDate={`${formatDateTime(
                R.path(['race_detail', 'race', 'start_time'], each)
              )} - ${formatDateTime(
                R.path(['race_detail', 'race', 'last_submit_time'], each)
              )}`}
            />
          </div>
        ))}
        <Pagination
          style={{ textAlign: 'center', marginBottom: 10 }}
          defaultCurrent={1}
          defaultPageSize={5}
          total={this.state.participants.length}
          onChange={(pageXOffset, _) => this.handlePaginateChange(pageXOffset)}
        />
        <RequireLogin />
      </div>
    )
  }
}

export default Profile



// WEBPACK FOOTER //
// /opt/build/repo/src/containers/Profile.js